import { gatewayPhone } from "../../../../../../gateways/gatewayPhone";
import { TransferAvailableResponse } from "../types/transfer.types";

export const getTransferAvailable = async (
    companyId: string | number
): Promise<TransferAvailableResponse> => {
    const { data } = await gatewayPhone.get<TransferAvailableResponse>(
        `/company/agent-status/${companyId}`
    );

    return data;
};